import { render } from "./ReferencesAction.vue?vue&type=template&id=fb27a774&scoped=true&ts=true"
import script from "./ReferencesAction.vue?vue&type=script&lang=ts"
export * from "./ReferencesAction.vue?vue&type=script&lang=ts"

import "./ReferencesAction.vue?vue&type=style&index=0&id=fb27a774&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb27a774"]])

export default __exports__